/* eslint-disable no-await-in-loop, padded-blocks, no-empty-pattern */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
};

export const actions = {
  async archiveTOG({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);
    await api.put(`/targetObjectGoal/${params.cat}/archiveTOG/${params.id}`).then(async () => {
      commit('SET_SUBMIT_SUCCESS', true);
    }).catch((exception) => {
      console.error('Enter api.put /targetObjectGoal/{cat}/archiveTOG/{id} catch()');
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
      console.error('Exit api.put /targetObjectGoal/{cat}/archiveTOG/{id} catch()');
    });
  },
  async createTOG({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);
    await api.put(`/targetObjectGoal/${params.cat}/createTOG?newName=${params.name}&newTargetObjectives=${params.newTargetObjectives}&newGoalObjectives=${params.newGoalObjectives}&newObjectiveTargets=${params.newObjectiveTargets}&newObjectiveGoals=${params.newObjectiveGoals}&newGoalPriority=${params.newGoalPriority}`).then(async () => {
      commit('SET_SUBMIT_SUCCESS', true);
    }).catch((exception) => {
      console.error('Enter api.put /targetObjectGoal/{cat}/createTOG/{id} catch()');
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
      console.error('Exit api.put /targetObjectGoal/{cat}/createTOG/{id} catch()');
    });
  },
  async updateTOG({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);
    await api.put(`/targetObjectGoal/${params.cat}/updateTOG?selectedDropdownItem=${params.selectedDropdownItem}&selectedTargetItems=${params.selectedTargetItems}&selectedObjectiveItems=${params.selectedObjectiveItems}&selectedGoalItems=${params.selectedGoalItems}&selectedProjectResourcePriority=${params.selectedProjectResourcePriority}`).then(async () => {
      commit('SET_SUBMIT_SUCCESS', true);
    }).catch((exception) => {
      console.error('Enter api.put /targetObjectGoal/{cat}/updateTOG/{id} catch()');
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
      console.error('Exit api.put /targetObjectGoal/{cat}/updateTOG/{id} catch()');
    });
  },
  async exportTOG({ commit }, params) {
    commit('SET_ERROR_MESSAGE', null);
    await api.put(`/targetObjectGoal/${params.projectId}/exportTOG`, params.projectId, { responseType: 'blob' }).then(async (response) => {
      const blobUrl = URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement('a');
      a.href = blobUrl;
      const filenameToDownload = params.projectName.replace(/[:*?<>|"\\/]/g, '-');
      a.download = `project_${filenameToDownload}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
      commit('SET_SUBMIT_SUCCESS', true);
    }).catch((exception) => {
      console.error('Enter api.put /targetObjectGoal/{projectId}/exportTOG catch()');
      console.error(exception);
      commit('SET_ERROR_MESSAGE', exception);
      console.error('Exit api.put /targetObjectGoal/{projectId}/exportTOG/ catch()');
    });
  },
};

export const mutations = {
  SET_SUBMIT_SUCCESS(state, value) {
    state.submitSuccess = value;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
};

export const getters = {
};
